// Get the app (WEB-10): the install sheet, from the Menu any time and from the website's Get the app
// link (?install=1). Where the browser offers an install, one button opens its dialog; where it never
// does (iPhone, a browser inside another app, a browser that has not offered yet), the sheet says how,
// step by step. Never inside the Lagos Life frame (lib/install gives no way there).
import { useEffect, useState } from 'react';
import { promptInstall, useInstallWay } from '../lib/install';
import { useUi } from '../store/ui';
import { S } from '../strings';

/** The icon the phone will get: the one the page points at now (the season's or the player's pick). */
const iconNow = () =>
  document.head.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]')?.href ?? '/icons/jollof-180.png';

export function InstallSheet() {
  const set = useUi((s) => s.set);
  const way = useInstallWay();
  const [done, setDone] = useState(false);
  const close = () => set({ installSheet: false });
  useEffect(() => {
    const esc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') set({ installSheet: false });
    };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [set]);
  const steps = way && way !== 'prompt' ? S.install.steps[way] : null;
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: Escape and the Close button cover the keyboard
    // biome-ignore lint/a11y/noStaticElementInteractions: the backdrop closes the sheet
    <div className="sheet install-sheet" onClick={close}>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: only stops the backdrop's click */}
      <section
        className="sheet__panel wh-board sheet--board"
        role="dialog"
        aria-modal="true"
        aria-labelledby="install-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="wh-board__band sheet__band">
          <h2 id="install-title">{S.install.band}</h2>
          <button type="button" className="wh-btn wh-btn--sm sheet__close" onClick={close}>
            {S.menu.close}
          </button>
        </header>
        <div className="sheet__body install-sheet__body">
          <div className="install-sheet__app">
            <img src={iconNow()} width={64} height={64} alt="" />
            <p>{done || !way ? (done ? S.install.done : S.install.have) : S.install.lead}</p>
          </div>
          {way === 'prompt' && !done && (
            <button
              type="button"
              className="wh-btn wh-btn--carry wh-btn--md wh-btn--block"
              onClick={async () => {
                if ((await promptInstall()) === 'accepted') setDone(true);
              }}
            >
              {S.install.go}
            </button>
          )}
          {steps && (
            <ol className="install-sheet__steps">
              {steps.map((s, i) => (
                <li key={s}>
                  <span className="install-sheet__n">{i + 1}</span>
                  <span>{s}</span>
                </li>
              ))}
            </ol>
          )}
          {(done || !way || steps) && (
            <button type="button" className="wh-btn wh-btn--quiet wh-btn--md wh-btn--block" onClick={close}>
              {S.install.ok}
            </button>
          )}
        </div>
      </section>
    </div>
  );
}
